import React from "react";
import styles from "./styles.css";
import H2 from "../../shared/h2/component";
import MoreCarsForYouCard from "../more-cars-for-you-card/component";
import PropTypes from "prop-types";

const MoreCarsForYouRevamp = ({content,
    config,
    allFilters,
    resetCarListConnect,
    reloadCarListConnect,
    updateSelectedOnScreenFilterConnect,
    updateAppliedFiltersConnect,
    isCdpRevamp,

    clearAllFiltersConnect}) => {
    const {moreCars = [] } = content || {};
    return (
        <div styleName={`${isCdpRevamp ? "styles.revampWrapper" : "styles.wrapper"}`}>
            {isCdpRevamp ? <h3>More cars for you</h3> : <H2 text="More cars for you" />}
            <div styleName={"styles.cardOuter"}>
                {
                    moreCars.map(item => {
                        return (<MoreCarsForYouCard item={item}
                            config={config}
                            allFilters={allFilters}
                            resetCarListConnect={resetCarListConnect}
                            reloadCarListConnect={reloadCarListConnect}
                            updateSelectedOnScreenFilterConnect={updateSelectedOnScreenFilterConnect}
                            updateAppliedFiltersConnect={updateAppliedFiltersConnect}
                            clearAllFiltersConnect={clearAllFiltersConnect}
                        />);
                    })
                }
            </div>
        </div>
    );
};
MoreCarsForYouRevamp.propTypes = {
    content: PropTypes.object,
    allFilters: PropTypes.object,
    updateSelectedOnScreenFilterConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    updateAppliedFiltersConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    config: PropTypes.object,
    isCdpRevamp: PropTypes.bool
};
export default MoreCarsForYouRevamp;
